export default __webpack_public_path__ + "static/media/projector.68eeb2cb.svg";